<form [formGroup]="form" (ngSubmit)="submitForm()">
  <h2 mat-dialog-title>Bulk Activate</h2>
  <mat-dialog-content class="mat-typography">
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
    <div *ngIf="isLoading" class="loading-progress">
      <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
      <div class="percent">{{ progress }}%</div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button color="warn" mat-button mat-dialog-close>Cancel</button>
    <button
      mat-button
      color="success"
      [mtBasicSpinner]="isLoading"
      [disabled]="form.invalid"
      mat-button
      type="submit"
    >
      Submit
    </button>
  </mat-dialog-actions>
</form>
